import { Modal } from '@chakra-ui/react';
import styled from 'styled-components';

interface ImageAreaRepresentationProps {
  $largura: number;
  $comprimento: number;
  boundies: DOMRect | undefined;
}

export const ImageAreaRepresentation = styled.div<ImageAreaRepresentationProps>`
  background-color: #f4f4f4;
  border: 1px solid #b3b3b3;
  position: relative;
  margin: 0 auto;
  max-height: 130px;
  max-width: 280px;
  min-height: 2rem;
  min-width: 2rem;
  aspect-ratio: ${({ $comprimento, $largura }) => `${$comprimento / $largura}`};
  display: ${({ $comprimento, $largura }) => ($comprimento > 0 && $largura > 0 ? 'block' : 'none')};
  margin-bottom: 1rem;

  &:after {
    content: '${({ $largura }) => `${$largura}m`}';
    display: inline-block;
    position: absolute;
    top: calc(50% - 12px);
    right: ${({ boundies }) => `calc(${boundies?.width || 0}px + 10px)`};
  }
  &:before {
    content: '${({ $comprimento }) => `${$comprimento}m`}';
    display: inline-block;
    position: absolute;
    bottom: -35px;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;
